module.exports = __webpack_public_path__ + "symbol-reverse.34ac1ff04f0f5becf2cf7accae2045fb.svg";